import type { GenericObject } from '~/types/common'
import type { PresetAssignmentConflict } from '~/types/configurationPreset'

interface ApiErrorEnvelope {
  detail?: string
  errors?: { message?: string; value?: unknown }[]
}

const errorEnvelope = (error: GenericObject): ApiErrorEnvelope | undefined =>
  (error.data ?? error.response?._data) as ApiErrorEnvelope | undefined

export const getApiErrorDetail = (error: GenericObject): string | null => {
  const data = errorEnvelope(error)
  if (!data) return null
  if (typeof data.detail === 'string' && data.detail.length > 0) return data.detail
  return data.errors?.find((e) => typeof e.message === 'string' && e.message.length > 0)?.message ?? null
}

// BE uses goerr.Join: only the first line of `detail` is the stable error text to map on.
export const matchBackendErrorKey = (
  error: GenericObject,
  keysByBackendMessage: Record<string, string>
): string | null => {
  const detail = getApiErrorDetail(error)
  if (!detail) return null
  return keysByBackendMessage[detail.split('\n')[0].trim()] ?? null
}

export const isConflictError = (error: GenericObject): boolean => error.status === 409 || error.statusCode === 409

const isPresetAssignmentConflict = (value: unknown): value is PresetAssignmentConflict =>
  typeof value === 'object' &&
  value !== null &&
  typeof (value as PresetAssignmentConflict).assetId === 'number' &&
  typeof (value as PresetAssignmentConflict).groupId === 'number' &&
  typeof (value as PresetAssignmentConflict).presetId === 'number'

export const getPresetAssignmentConflicts = (error: GenericObject): PresetAssignmentConflict[] =>
  (errorEnvelope(error)?.errors ?? []).map((e) => e.value).filter(isPresetAssignmentConflict)
